import React from 'react'
import formatMessage from 'format-message'
import HighlightRect from './HighlightRect'
import Annotation from './Annotation'
import { getRectFromCoords } from './utils'
import { saveCommentFn } from './utils.js'
import SecondaryControls from '../SecondaryControls'
import { DEFAULT_HIGHLIGHT_ANNOTATION_COLOR } from '../constants'
import './HighlightAnnotation.css'

export default function HighlightAnnotation(props) {
  const {
    annotation,
    commentReplies,
    onCreateAnnotation,
    onCurrentColorChange,
    onUpdateAnnotation,
    selectionBoxPadding,
    sessionUserObject,
    viewportHeight,
    viewportScale,
  } = props

  const updateColor = (color) => {
    onUpdateAnnotation(viewportHeight, viewportScale, { ...annotation, color })
    onCurrentColorChange(color, 'highlight')
  }

  const handleCommentSave = saveCommentFn({
    annotation,
    commentReplies,
    onUpdateAnnotation,
    viewportHeight,
    viewportScale,
    onCreateAnnotation,
    sessionUserObject,
  })

  const [[x1, y1], [x2, y2]] = annotation.rect
  const width = x2 - x1
  const height = y1 - y2

  if (!(annotation.coords instanceof Array)) {
    throw new Error('coords missing on strikeout annotation')
  }

  const rects = annotation.coords
    .map(getRectFromCoords)
    .filter((rect) => rect.top !== rect.bottom && rect.left !== rect.right) // Remove empty rects
    .map((rect, index) => {
      const transformedRect = {
        left: rect.left - x1 + selectionBoxPadding,
        top: rect.top - y2 + selectionBoxPadding,
        right: rect.right - x1 + selectionBoxPadding,
        bottom: rect.bottom - y2 + selectionBoxPadding,
      }
      return <HighlightRect key={index} rect={transformedRect} />
    })

  const secondaryControls = (
    <SecondaryControls
      controlMode="highlight"
      currentColor={annotation.color}
      onCurrentColorChange={updateColor}
    />
  )

  return (
    <Annotation
      {...props}
      containerClassName="HighlightAnnotationContainer"
      className="HighlightAnnotation"
      iconColor={annotation.color ? annotation.color : DEFAULT_HIGHLIGHT_ANNOTATION_COLOR}
      height={height}
      id={annotation.id}
      isMovable={false}
      onCommentSave={handleCommentSave}
      rect={annotation.rect}
      render={(_isSvgContainerFocused) => (
        <g
          role="presentation"
          fill={
            typeof annotation.color === 'string'
              ? annotation.color
              : DEFAULT_HIGHLIGHT_ANNOTATION_COLOR
          }
        >
          {rects}
        </g>
      )}
      secondaryControls={secondaryControls}
      title={formatMessage('Highlight annotation')}
      user_name={annotation.user_name}
      width={width}
      x={x1}
      y={y2}
    />
  )
}
